export const blockReaderContentAction = event => {
  const target = event.target;
  if (
    target?.closest &&
    !target.closest('[data-br-reader-text]') &&
    target.closest('input, textarea, [contenteditable="true"]')
  ) {
    return;
  }
  event.preventDefault();
};

export const blockReaderContextMenu = (
  event,
  { isProtectedReader, isSmallScreen }
) => {
  if (isProtectedReader && isSmallScreen) event.preventDefault();
};

export const blockReaderPrintShortcut = event => {
  if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'p') {
    event.preventDefault();
  }
};
